<template>
  <div class="users _flxccc">
    <div class="users__load _flxcs">
      <header class="content-heading">
        <h1 class="txt-header">Users</h1>
      </header>
      <section class="content-main">
      <div class="users__container">
        <div class="users__container__add">
          <button v-if="!showAdd" class="action-button" title="New user" @click="showAdd=!showAdd"><i class="material-icons">add</i>Create User</button>
          <add v-if="showAdd" v-on:close="showAdd=false"></add>
        </div>
        <div class="users__container__filter">
          <div style="width:400px;float:right">
            <input placeholder="Filter users" type="text" name="usersFilter" v-model="textFilter" />
          </div>
        </div>
      </div>
      <list :items="filteredUsers"></list>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import List from './list'
import Add from './add'

export default {
  name: 'users',
  components: { List, Add },
  computed: {
    ...mapGetters(['users', 'user']),
    filteredUsers() {
      const users = this.users
      return users.filter((user, i, arr) => {
        return (user.name || user.email || '').toLowerCase().indexOf((this.textFilter || '').toLowerCase()) >= 0
      })
    }
  },
  created() {
    if (!this.user.admin) {
      this.$router.push('project')
    } else {
      this.loadUsers();
      this.loadTenants();
    }
  },
  data: () => ({
    showAdd: false,
    textFilter: null
  }),
  methods: {
    ...mapActions(['loadUsers', 'loadTenants'])
  }
}
</script>